export default class uploadFile {
    constructor() {
        return {
            template: `
                <label class="file-upload-button btn btn-sm" ng-disabled="$ctrl.disabled">
                     <span>{{$ctrl.placeholder || 'Upload File'}}</span>
                     <input type="file" accept=".txt" style="display: none;">
                </label>
            `,
            bindings: {
                placeholder: '@',
                disabled: '<',
                onUpload: '&'
            },
            controller: UploadFileCtrl
        }
    }
}

class UploadFileCtrl {
    constructor (element) {
        const fileInput = element.find('input');
        fileInput.on("change", () => {
            const file = fileInput[0].files[0];
            this.onUpload({file});
            fileInput[0].value = '';
        })
    }
}
UploadFileCtrl.$inject = ['$element'];
